import { MijnRoute } from '../../mijn-navigatie.model';

export const MESSAGE_VIEW: MijnRoute = {
    path: 'berichten/:id',
    navigationEvent: 'toBericht',
    regex: /^\/berichten\/[^/]+$/,
    webcomponent: 'mijn-berichten-overzicht-webcomponent'
};
